export default {"src":"/_next/static/media/glg-dark-text.ae6a6eec.svg","height":60,"width":648,"blurWidth":0,"blurHeight":0};